import React, { useEffect, useState } from "react";
import "./App.css";
import CreatePost from './CreatePost';
import Farmposts from './Farmposts';
import LoginForm from './LoginForm';
import LoginModal from './LoginModal';
import UserProfile from './UserProfile';
// Import the functions you need from the SDKs you need
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getDatabase, ref, onValue, get, off } from "firebase/database";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { LoadScript} from '@react-google-maps/api';
import { CgProfile, CgCloseO, CgMail } from "react-icons/cg";
import { AiOutlineClose } from "react-icons/ai";
import plotlogo from './images/plotlogo.svg';
import leftleaf from './images/LEFTLEAF.svg';
import lilleaf from './images/LILLEAF.svg';
import rightleaf from './images/RIGHTLEAF.svg';
import branch from './images/BRANCH.svg';
import fruit from './images/FRUIT.svg';
import Messenger from './Messenger';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation
} from "react-router-dom";




const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function MainApp() {
  const [user, setUser] = useState(null);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [showFarmposts, setShowFarmposts] = useState(true);
  const [showCreatePostForm, setShowCreatePostForm] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showMessengerBlock, setShowMessengerBlock] = useState(false);
  const [showMessenger, setShowMessenger] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLiteLoading, setIsLiteLoading] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [isMessengerVisible, setIsMessengerVisible] = useState(false);
  const [mobileConversationView, setMobileConversationView] = useState(true);
  const [posts, setPosts] = useState([]);
  const [selectedUserProfile, setSelectedUserProfile] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [isMessageEditMode, setIsMessageEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState('farmposts');
  const [farmpostsKey, setFarmpostsKey] = useState(Date.now());
  



  
  const navigate = useNavigate();
  const location = useLocation();


  const auth = getAuth();
  const currentUser = auth.currentUser;
  const currentUserId = currentUser ? currentUser.uid : null;
  const db = getDatabase();

  const handleReload = () => {
    // window.location.reload();
};



  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "") {
      setShowFarmposts(true);
      setShowCreatePostForm(false);
      setShowMessenger(false);
      setIsMessengerVisible(false);
      setShowUserProfile(false);
    } else {
      setShowFarmposts(false);
    
    }
  }, [location.pathname]);

  useEffect(() => {
    switch (location.pathname) {
      case '/':
        setCurrentPage('farmposts');
        setFarmpostsKey(Date.now());
        break;
      case '/messenger':
        setCurrentPage('messenger');
        break;
      case '/profile':
        setCurrentPage('profile');
        break;
      case '/create-post':
        setCurrentPage('create-post');
        break;
      default:
        setCurrentPage('farmposts');
    }
  }, [location.pathname]);
  

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
    });

    // Cleanup the observer on component unmount
    return () => unsubscribe();
  }, []);

  const handleAuthentication = () => {
    setIsAuthenticated(true);
    setShowLoginModal(false); // Close the modal once the user is authenticated
  };
 
  function LoginModal({ children, setIsAuthenticated, isAuthenticated }) {
    return ( 
      <div className="modal_overlay">
        <div className="modal_content">
          {children}
        </div>
      </div>
    );
  }

  
  useEffect(() => {
    const allConversationsRef = ref(db, 'conversations');
    const unsubscribes = [];

    // This function checks if there are any unread received messages in the provided messages data
    const checkUnreadMessages = (allMessages) => {
        for (let msgKey in allMessages) {
            const msg = allMessages[msgKey];
            if (msg.senderId !== currentUserId && !msg.read) {
                return true;
            }
        }
        return false;
    };

    const handleMessagesChange = (messagesSnapshot) => {
        if (messagesSnapshot.exists()) {
            const hasUnread = checkUnreadMessages(messagesSnapshot.val());
            setHasUnreadMessages(hasUnread);
        }
    };

    // This function sets up a listener for each conversation the current user is a part of
    const setupListeners = async () => {
        const allConvosSnapshot = await get(allConversationsRef);
        if (allConvosSnapshot.exists()) {
            const allConvos = allConvosSnapshot.val();
            
            for (let convoId in allConvos) {
                const convo = allConvos[convoId];
                if (convo.participant1 === currentUserId || convo.participant2 === currentUserId) {
                    const messagesRef = ref(db, `messages/${convoId}`);
                    const unsubscribe = onValue(messagesRef, handleMessagesChange);
                    unsubscribes.push(() => off(messagesRef, 'value', unsubscribe));
                }
            }
        }
    };

    setupListeners();

    // Cleanup: Remove all the listeners when the component unmounts
    return () => {
        unsubscribes.forEach(unsub => unsub());
    };

}, [currentUserId, db]);





  // console.log('Current hasUnreadMessages state:', hasUnreadMessages);
  // console.log('Current state showFarmposts:', showFarmposts);
  return (
  
<div className="main_app_container">

 
  <div className="main_app_body">
  

  <div className="top_navigation_container">

  <div className="top_navigation">  
 
  {isLoading && (
            <div className="loader_container">
                <span className="loader"></span>
            </div>
        )}

{/* {isLoading && (
           <img className="logo_image" src={plotlogo}/>
        )} */}


       <div className="fruit_animation">
       <div className="fruit_animation_container">
                      <img src={leftleaf} className="fruitlogo_leftleaf"/>            
                      <img src={rightleaf} className="fruitlogo_rightleaf"/>
                      <img src={lilleaf} className="fruitlogo_lilleaf"/>
                      <img src={branch} className="fruitlogo_branch"/>
                      <img src={fruit} className="fruitlogo_fruit"/>
                      </div>
                      </div>
      
 





 

 { (currentPage === 'farmposts' || currentPage === 'messenger') && !showCreatePostForm && (
  user ? (
    <Link to="/profile">
      <button className="user_profile_nav_button" onClick={() => {
        setShowUserProfile(true);
        setCurrentPage('profile');
        setShowFarmposts(false);
        setShowMessenger(false);
        setMobileConversationView(false);
        setIsMessengerVisible(false);
        setSelectedUserProfile(null);
        setIsMessageEditMode(false);
      }}>
        <CgProfile />
      </button>
    </Link>
  ) : (
    <button className="user_profile_nav_button" onClick={() => setShowLoginModal(true)}>
      <CgProfile />
    </button>
  )
)}


{currentPage === 'profile' && <Link to="/"><button className="user_profile_nav_button" onClick={() => {
  setShowUserProfile(false);
setShowFarmposts(true);
setCurrentPage('farmposts');
setMobileConversationView(false);
setSelectedConversation(null);
setIsMessengerVisible(false);
navigate('');
}}>
  <CgCloseO />
</button></Link>}


{ (currentPage === 'farmposts' || currentPage === 'profile') && !showCreatePostForm && (
  user ? (
    <Link to="/messenger">
      <button className="user_profile_nav_button" onClick={() => {
        setShowMessenger(true);
        setCurrentPage('messenger');
        setShowUserProfile(false);
        setShowCreatePostForm(false);
        setSelectedUserProfile(null);
        setIsMessengerVisible(prev => !prev);
        setShowMessengerBlock(false);
        setIsMessageEditMode(false);
        setMobileConversationView(true);

      }}>
        <CgMail />
      </button>
    </Link>
  ) : (
    <button className="user_profile_nav_button" onClick={() => setShowLoginModal(true)}>
      <CgMail />
    </button>
  )
)}

{currentPage === 'messenger' && <Link to=""><button className="user_profile_nav_button" onClick={() => {
  setShowUserProfile(false);
  setShowMessenger(false);
  setCurrentPage('farmposts');
  setSelectedConversation(null);
  setSelectedUserProfile(null);
  setMobileConversationView(false);
  setIsMessengerVisible(false);
  setIsMessageEditMode(false);
  navigate('');
  setShowFarmposts(true);
}}>
  <CgCloseO />
</button></Link>}


{currentPage === 'create-post' && <Link to=""><button className="user_profile_nav_button" onClick={() => {
  setShowCreatePostForm(false);
setShowFarmposts(true);
setCurrentPage('farmposts');
navigate('');
}}>
  <CgCloseO />
</button></Link>}

{hasUnreadMessages && !showMessenger && <span className="unread-dot"></span>}



</div></div>

{showLoginModal && (
  <LoginModal>
  <button className="login_form_close_button" onClick={() => {setShowLoginModal(false);}}><AiOutlineClose /></button>
  <LoginForm onAuthenticated={handleAuthentication} setIsLoading={setIsLoading} setShowFarmposts={setShowFarmposts} setShowUserProfile={setShowUserProfile} />
</LoginModal>
)}


<LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
<Routes>
  {currentPage === 'profile' && (
    <Route path="/profile" element={<UserProfile handleReload={handleReload} onAuthenticated={handleAuthentication} setShowUserProfile={setShowUserProfile} setShowFarmposts={setShowFarmposts} setIsLoading={setIsLoading} userLocation={userLocation} setUserLocation={setUserLocation} setMobileConversationView={setMobileConversationView} />} />
  )}

  {currentPage === 'create-post' && user && (
    <Route path="/create-post" element={<CreatePost setIsLoading={setIsLoading} isLoading={isLoading} setShowCreatePostForm={setShowCreatePostForm} showCreatePostForm={showCreatePostForm} setShowFarmposts={setShowFarmposts} showFarmposts={showFarmposts} />} />
  )}

  {currentPage === 'farmposts' && (
    <Route path="/" element={<Farmposts setShowUserProfile={setShowUserProfile} key={farmpostsKey} setCurrentPage={setCurrentPage} selectedConversation={selectedConversation} setSelectedConversation={setSelectedConversation} user={currentUser} setSelectedUserProfile={setSelectedUserProfile} selectedUserProfile={selectedUserProfile} posts={posts} setPosts={setPosts} setMobileConversationView={setMobileConversationView} mobileConversationView={mobileConversationView} setIsLoading={setIsLoading} userLocation={userLocation} setUserLocation={setUserLocation} showMessenger={showMessenger} setShowMessenger={setShowMessenger} isMessengerVisible={isMessengerVisible} setIsMessengerVisible={setIsMessengerVisible} setShowLoginModal={setShowLoginModal} setShowCreatePostForm={setShowCreatePostForm} showCreatePostForm={showCreatePostForm} showFarmposts={showFarmposts} setShowFarmposts={setShowFarmposts} />} />
  )}

  {currentPage === 'messenger' && currentUser && (
    <Route path="/messenger" element={<Messenger isLoading={isLoading} setIsLoading={setIsLoading} isMessageEditMode={isMessageEditMode} setIsMessageEditMode={setIsMessageEditMode} setHasUnreadMessages={setHasUnreadMessages} selectedConversation={selectedConversation} setSelectedConversation={setSelectedConversation} setSelectedUserProfile={setSelectedUserProfile} selectedUserProfile={selectedUserProfile} currentUserId={currentUser.uid} setMobileConversationView={setMobileConversationView} mobileConversationView={mobileConversationView} posts={posts} setPosts={setPosts} />} />
  )}
</Routes>


  </LoadScript>
  
</div>


</div>
 
 
 );
}

export default MainApp;
